import { getInitialState, getPath } from "../../utils";

const initialState = {
  restrictedPayoutDrivers: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_RESTRICTED_PAYOUT_DRIVERS": {
      return setRestrictedPayoutDrivers(state, action);
    }
    default: {
      return state;
    }
  }
}

const setRestrictedPayoutDrivers = (state, action) => {
  return {
    ...state,
    restrictedPayoutDrivers: getPath(
      action.payload,
      "restricted_payout_driver_details",
      []
    ),
  };
};
